import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  deleteKnowledgebaseAction,
  listKnowledgebaseAction,
} from '../../../../../store/actions/knowledgebase';

const DeleteKnowledgeBase = ({
  isOpen,
  setIsOpen,
  filterValue,
  knowledgebaseId,
}) => {
  const dispatch = useDispatch();
  const { knowledgebaseItem } = useSelector(
    (state) => state?.knowledgebaseState
  );

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDelete = async () => {
    if (knowledgebaseItem) {
      dispatch(
        deleteKnowledgebaseAction(knowledgebaseId, () => {
          handleClose();
          dispatch(listKnowledgebaseAction(filterValue));
        })
      );
    }
  };

  return (
    <Modal
      title="Delete Knowledge Base Entry"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={400}
    >
      <div className="flex flex-col items-center py-4">
        <ExclamationCircleOutlined
          style={{ fontSize: '48px', color: '#ff4d4f', marginBottom: '16px' }}
        />
        <h3 className="text-lg font-medium mb-2">Confirm Deletion</h3>
        <p className="text-center mb-6">
          Are you sure you want to delete the knowledge base entry? This action
          cannot be undone.
        </p>
        <div className="flex justify-end w-full">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button type="primary" danger onClick={handleDelete}>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteKnowledgeBase;
